export const LOAN_INFO = "loan_info";

//----------------------------------------------------------------
export const MOBILE_NUMBER = "mobile_number";
export const REFERENCE_NUMBER = "reference_number";
//basic information
export const LOAN_REQUEST_STATUS = "loan_request_status";
export const SUPPLIER_SETTLEMENT_STATUS = "supplier_settlement_status";
export const LOAN_REQUEST_SOURCE = "loan_request_source";
export const LOAN_TEMPLATES = "loan_template";
export const SUPPLIER_UESR = "supplier_user";
//
export const REQUEST_DETAIL = "request_detail";
export const REFERENCE_KEY = "reference_Key";
export const SUPPLIER_CREDIT = "supplier_credit";
export const VALID_FORM = "valid_form";
export const GET_SUPPLIER_ATTACHMENT = "get_supplier_attachment";
export const NATIONAL_CODE = "national_code";
export const INSTALLMENT_COUNT = "installmen_count";
export const INSTALLMENT_STEP = "installmen_step";
export const GET_CUSTOMER_REGISTRATION_INFO = "get_customer_registration_info";
/* key of customer registration info*/
export const HAS_REGISTER_REQUEST = "has_register_request";
export const IS_EDITABLE = "is_editable";
export const IS_CANCELABLE = "is_cancelable";
export const CUSTOMER_INFO = "customer_info";
export const LOAN_TEMPLATE_INFOS = "loan_template_infos";
export const EXISTING_LOANREQUEST = "existing_loanRequest";
/* id loan*/
export const LOAN_ID = "loan_id";
export const CANCELLOAN_REQUEST = "cancelLoan_request";
export const Timer_INIT = "timer_init";
export const VALUES_CONFIRM_FACILITY = "values_confirm_facility";

export const SUPPLIER_ATTACHMENTS = "supplier_attachments";
export const SUPPLIER_ATTACHMENTS_UPLOADED = "supplier_attachments_uploaded";
export const CUSTOMER_BIRTHDATE = "customer_birthDate";
export const CUSTOMER_MOBILENUMBER = "customer_mobileNumber";
export const LOAN_AMOUNT = "loan_amount";
export const POSTAL_CODE = "postal_Code";
export const INQUIRY_OTP_REF_KEY = "inquiry_otp_ref_key";
export const TEXT_DROPDOWN = "text_dropdown";
export const TABLE_FILTER = "table_filter";
export const FILTER_CACHE = "filter_cache";
export const WORK_FLOW_TYPE = "work_flow_type";
export const ACTIVE_DIV = "active_div";
export const SETTLEMENT_REQUEST_KEY = "SETTLEMENT_REQUEST_KEY";

export const DEL_CHIP = "del_chip";
/* SupplierUser*/
export const SUPPLIER_USER_INFO = "supplier_user_info";
// todo new
/*

export const LOAN_INFO = "loan_info";

//----------------------------------------------------------------
export const MOBILE_NUMBER = "mobile_number";
export const REFERENCE_NUMBER = "reference_number";
export const LOAN_REQUEST_STATUS = "loan_request_status";
export const SUPPLIER_SETTLEMENT_STATUS = "supplier_settlement_status";
export const REQUEST_DETAIL = "request_detail";
export const REFERENCE_KEY = "reference_Key";
export const SUPPLIER_CREDIT = "supplier_credit";
export const VALID_FORM = "valid_form";
export const GET_SUPPLIER_ATTACHMENT = "get_supplier_attachment"

*/
export const TABLE_FILTER_SUPP = "table_filter_supp";
export const TABLE_FILTER_CHEQUE = "table_filter_cheque";
export const TABLE_FILTER_SUPP_ROWNumber = "table_filter_supp_rownumber";
export const TABLE_FILTER_ROWNumber = "table_filter_rownumber";
export const TABLE_FILTER_ROWNUMBERCMP = "table_filter_rownumbercmp";
export const TABLE_FILTER_ROWNUMBERREQCMP = "table_filter_rownumberreqcmp";
export const TABLE_FILTER_CUSTOMER_ROWNumber =
  "table_filter_customer_rownumber";
export const TABLE_FILTER_APP_ROWNumber = "table_filter_supp_rownumber";
export const TABLE_SUPPNOTICE_ROWNumber = "table_suppnotice_rownumber";
export const TABLE_FILTER_APP = "table_filter_app";
export const LOAN_TEMPLATE_SETAD = "loan_template_setad";
export const LOAN_REQUEST_STATUS_SETAD = "loan_request_status_setad";
export const CHEQUE_TYPE_STATUS_SETAD = "cheque_type_status_setad";
export const SUPPLIER_SETTLEMENT_STATUS_SETAD =
  "supplier_settlement_status_setad";
export const SUPPLIERIDS = "supplierids";
export const LOAN_TEMPLATE_APP = "loan_template_app";
export const LOAN_REQUEST_STATUS_APP = "loan_request_status_app";
export const STATECARTABLE = "statecartable";
// MAP
export const TREE_MAP = "tree_map";
export const LAT_LNG = "lat_lng";

//filter for cartable
export const NATIONAL = "national";
export const SUPPLIER_ID = "supplier_id";
export const NOTICE_FILTER = "notice_filter";

//pdfComponent
export const FILEURL = "fileurl";

//suppliersInfo
export const NOTICEkEY = "noticekey";

//store state management
export const STORESTATE = "storekey";

// key response service banks
export const BANKLIST = "banklist";
//store and branch
export const STOREID = "storeid";
export const BRANCHID = "branchid";
export const CACHEROUTE = "cacheRoute";
//category
export const MAINCATEGORYID = "maincategoryid";
